import type { FC } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'

import { siteConfig } from '@/constants/site'

interface LogoMarkProps {
    className?: string
}

export const LogoMark: FC<LogoMarkProps> = ({ className }) => (
    <svg viewBox='0 0 32 32' aria-hidden='true' className={cn('size-8 shrink-0', className)}>
        <rect width='32' height='32' rx='9' className='fill-primary' />
        <path d='M9 9.5h14a1.5 1.5 0 0 1 0 3h-5.5V22a1.5 1.5 0 0 1-3 0v-9.5H9a1.5 1.5 0 0 1 0-3Z' fill='#ffffff' />
        <circle cx='22.5' cy='21.5' r='2.5' fill='#a5f3c4' />
    </svg>
)

interface LogoProps {
    href?: string
    className?: string
}

export const Logo: FC<LogoProps> = ({ href = '/', className }) => (
    <Link href={href} className={cn('inline-flex items-center gap-2.5 rounded-lg outline-none focus-visible:ring-3 focus-visible:ring-ring/40', className)}>
        <LogoMark />
        <span className='font-heading text-lg font-bold tracking-tight text-foreground'>
            {siteConfig.name}
        </span>
    </Link>
)
